import defaultFileIcon from '@iconify-icons/vscode-icons/default-file'
import bashIcon from '@iconify-icons/vscode-icons/file-type-shell'
import cIcon from '@iconify-icons/vscode-icons/file-type-c'
import cppIcon from '@iconify-icons/vscode-icons/file-type-cpp3'
import csharpIcon from '@iconify-icons/vscode-icons/file-type-csharp'
import cssIcon from '@iconify-icons/vscode-icons/file-type-css'
import dartIcon from '@iconify-icons/vscode-icons/file-type-dartlang'
import diffIcon from '@iconify-icons/vscode-icons/file-type-diff'
import dockerfileIcon from '@iconify-icons/vscode-icons/file-type-docker'
import elixirIcon from '@iconify-icons/vscode-icons/file-type-elixir'
import erlangIcon from '@iconify-icons/vscode-icons/file-type-erlang'
import goIcon from '@iconify-icons/vscode-icons/file-type-go'
import graphqlIcon from '@iconify-icons/vscode-icons/file-type-graphql'
import groovyIcon from '@iconify-icons/vscode-icons/file-type-groovy'
import htmlIcon from '@iconify-icons/vscode-icons/file-type-html'
import iniIcon from '@iconify-icons/vscode-icons/file-type-ini'
import javaIcon from '@iconify-icons/vscode-icons/file-type-java'
import javascriptIcon from '@iconify-icons/vscode-icons/file-type-js-official'
import jsonIcon from '@iconify-icons/vscode-icons/file-type-json-official'
import kotlinIcon from '@iconify-icons/vscode-icons/file-type-kotlin'
import lessIcon from '@iconify-icons/vscode-icons/file-type-less'
import luaIcon from '@iconify-icons/vscode-icons/file-type-lua'
import makefileIcon from '@iconify-icons/vscode-icons/file-type-makefile'
import markdownIcon from '@iconify-icons/vscode-icons/file-type-markdown'
import nginxIcon from '@iconify-icons/vscode-icons/file-type-nginx'
import objectivecIcon from '@iconify-icons/vscode-icons/file-type-objectivec'
import perlIcon from '@iconify-icons/vscode-icons/file-type-perl'
import phpIcon from '@iconify-icons/vscode-icons/file-type-php'
import powershellIcon from '@iconify-icons/vscode-icons/file-type-powershell'
import pythonIcon from '@iconify-icons/vscode-icons/file-type-python'
import rIcon from '@iconify-icons/vscode-icons/file-type-r'
import rubyIcon from '@iconify-icons/vscode-icons/file-type-ruby'
import rustIcon from '@iconify-icons/vscode-icons/file-type-rust'
import scalaIcon from '@iconify-icons/vscode-icons/file-type-scala'
import scssIcon from '@iconify-icons/vscode-icons/file-type-scss'
import sqlIcon from '@iconify-icons/vscode-icons/file-type-sql'
import swiftIcon from '@iconify-icons/vscode-icons/file-type-swift'
import textIcon from '@iconify-icons/vscode-icons/file-type-text'
import typescriptIcon from '@iconify-icons/vscode-icons/file-type-typescript-official'
import vbnetIcon from '@iconify-icons/vscode-icons/file-type-vb'
import wasmIcon from '@iconify-icons/vscode-icons/file-type-wasm'
import yamlIcon from '@iconify-icons/vscode-icons/file-type-yaml'
import { Icon } from '@iconify/react'
import { cn } from '@w/ui/lib/utils'

export const codeHighlightingLanguages = [
  'text',
  'bash',
  'c',
  'cpp',
  'csharp',
  'css',
  'dart',
  'diff',
  'dockerfile',
  'elixir',
  'erlang',
  'go',
  'graphql',
  'groovy',
  'html',
  'ini',
  'java',
  'javascript',
  'json',
  'kotlin',
  'less',
  'lua',
  'makefile',
  'markdown',
  'nginx',
  'objectivec',
  'perl',
  'php',
  'powershell',
  'python',
  'r',
  'ruby',
  'rust',
  'scala',
  'scss',
  'sql',
  'swift',
  'typescript',
  'vbnet',
  'wasm',
  'yaml',
] as const

type CodeHighlightingLanguage = (typeof codeHighlightingLanguages)[number]

const languageIcons = {
  bash: bashIcon,
  c: cIcon,
  cpp: cppIcon,
  csharp: csharpIcon,
  css: cssIcon,
  dart: dartIcon,
  diff: diffIcon,
  dockerfile: dockerfileIcon,
  elixir: elixirIcon,
  erlang: erlangIcon,
  go: goIcon,
  graphql: graphqlIcon,
  groovy: groovyIcon,
  html: htmlIcon,
  ini: iniIcon,
  java: javaIcon,
  javascript: javascriptIcon,
  json: jsonIcon,
  kotlin: kotlinIcon,
  less: lessIcon,
  lua: luaIcon,
  makefile: makefileIcon,
  markdown: markdownIcon,
  nginx: nginxIcon,
  objectivec: objectivecIcon,
  perl: perlIcon,
  php: phpIcon,
  powershell: powershellIcon,
  python: pythonIcon,
  r: rIcon,
  ruby: rubyIcon,
  rust: rustIcon,
  scala: scalaIcon,
  scss: scssIcon,
  sql: sqlIcon,
  swift: swiftIcon,
  text: textIcon,
  typescript: typescriptIcon,
  vbnet: vbnetIcon,
  wasm: wasmIcon,
  yaml: yamlIcon,
} satisfies Record<CodeHighlightingLanguage, typeof defaultFileIcon>

export function LanguageIcon({ language }: { language: string }) {
  const icon = codeHighlightingLanguages.includes(
    language as CodeHighlightingLanguage,
  )
    ? languageIcons[language as CodeHighlightingLanguage]
    : defaultFileIcon

  return (
    <Icon
      aria-hidden="true"
      className={cn(
        'size-5',
        language === 'yaml' && 'rounded-sm bg-black p-0.5',
      )}
      icon={icon}
    />
  )
}

LanguageIcon.displayName = 'LanguageIcon'
